import React from 'react';
import {
  Collapse,
  Navbar,
  Nav,
  NavItem,
  Container,
  InputGroup,
  InputGroupAddon,
  Input,
  Button,
  UncontrolledAlert,
} from 'reactstrap';
import dashboardRoutes from 'routes/dashboard.jsx';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { ShoppingCart, Star, EnvelopeSimple, SignOut } from 'phosphor-react';
import api from '../../api/api';
import CircleFlag from './CircleFlag';
import SupportModal from './SupportModal';
import { processError } from '../../lib/lib';
import getSystemFrontendSettings from '../../lib/systemFrontendSettings';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      userddOpen: false,
      searchOpen: true,
      messagesddOpen: false,
      notificationsddOpen: false,
      color: 'primary',
      items: 0,
      searchValue: '',
      favorites: '0',
      supportModal: false,
      sent: '',
      searchAction: false,
      languages: [],
      link: '',
      supportButton: null,
    };
    this.toggle = this.toggle.bind(this);
    // this.userddToggle = this.userddToggle.bind(this)
    // this.messagesddToggle = this.messagesddToggle.bind(this)
    // this.notificationsddToggle = this.notificationsddToggle.bind(this)
    // this.searchToggle = this.searchToggle.bind(this)
    this.routeToCart = this.routeToCart.bind(this);
    this.search = this.search.bind(this);
    this.addToSearchValue = this.addToSearchValue.bind(this);
    this.supportModal = this.supportModal.bind(this);
    this.setSent = this.setSent.bind(this);
    this.logout = this.logout.bind(this);
  }

  toggle() {
    // if (this.state.isOpen) {
    //     this.setState({
    //         color: 'primary',
    //     })
    // } else {
    //     this.setState({
    //         color: 'white',
    //     })
    // }
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  routeToCart() {
    this.props.history.push('/cart');
  }

  // userddToggle() {
  //     this.setState({
  //         userddOpen: !this.state.userddOpen,
  //     })
  // }

  // searchToggle() {
  //     // this.refs.searchbarToggle.classList.toggle('toggled');
  //     this.setState({
  //         searchOpen: !this.state.searchOpen,
  //     })
  //     // this.refs.searchbarToggle.classList.toggle('opened');
  // }

  // messagesddToggle() {
  //     this.setState({
  //         messagesddOpen: !this.state.messagesddOpen,
  //     })
  // }

  // notificationsddToggle() {
  //     this.setState({
  //         notificationsddOpen: !this.state.notificationsddOpen,
  //     })
  // }

  getBrand() {
    let name;
    dashboardRoutes.map((prop) => {
      if (prop.collapse) {
        prop.views.map((prop) => {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      } else {
        if (prop.redirect) {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        } else {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        }
      }
      return null;
    });
    return name;
  }

  openSidebar() {
    document.documentElement.classList.toggle('nav-toggle');
    this.refs.sidebarToggle.classList.toggle('toggled');

    // close chat bar if open on smaller screens
    if (window.innerWidth < 993) {
      document.documentElement.classList.remove('nav-toggle-chat');
      this.refs.chatToggle.classList.remove('toggled');
    }
  }

  openChat() {
    document.documentElement.classList.toggle('nav-toggle-chat');
    this.refs.chatToggle.classList.toggle('toggled');

    // close menu bar if open on smaller screens
    if (window.innerWidth < 993) {
      document.documentElement.classList.remove('nav-toggle');
      this.refs.sidebarToggle.classList.remove('toggled');
    }
  }

  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  // updateColor() {
  //     if (window.innerWidth < 993 && this.state.isOpen) {
  //         this.setState({
  //             color: 'primary',
  //         })
  //     } else {
  //         this.setState({
  //             color: 'primary',
  //         })
  //     }
  // }

  componentWillMount() {
    // const systemP = new Promise((resolve) => cookies.get('system') ? resolve(JSON.parse(cookies.get('system'))) : api.getConfig().then((system) => resolve(system)))
    const systemP = new Promise((resolve) =>
      api.getConfig().then((system) => resolve(system))
    );
    systemP
      .then(({ language }) => {
        if (language) {
          const { available } = language;
          if (available) {
            available.forEach(({ countryCode, key }) =>
              this.setState({
                languages: [
                  {
                    code: key.toLowerCase(),
                    name: key.toUpperCase(),
                    countryCode: countryCode.toLowerCase(),
                  },
                  ...this.state.languages,
                ],
              })
            );
          }
        } else {
          this.setState({
            languages: [{ code: 'en', name: 'EN', countryCode: 'us' }],
          });
        }
      })
      .catch(() =>
        this.setState({
          languages: [{ code: 'en', name: 'EN', countryCode: 'us' }],
        })
      );
    // const favorites = cookies.get('favorites')
    api
      .getFavorites({
        end: 1000,
        start: 0,
        lang: this.props.i18n.language,
        token: cookies.get('accessToken'),
      })
      .then(({ count }) => cookies.set('favorites', count, { path: '/' }))
      .catch((e) => processError(e, this.props.history));

    getSystemFrontendSettings({ lang: this.props.i18n.language })
      .then((result) => {
        this.setState({ supportButton: result.supportButton });
        if (result && result.url && result.url.logo) {
          const {
            url: { logo },
          } = result;
          let link = logo[this.props.i18n.language];
          if (!link) link = logo.default;
          this.setState({ link });
        }
      })
      .catch((e) => processError(e, this.props.history));
  }

  componentDidMount() {
    setInterval(() => {
      const order = cookies.get('order');
      const favorites = cookies.get('favorites');
      order
        ? this.setState({ items: JSON.parse(order).length })
        : this.setState({ items: 0 });
      favorites && favorites !== 'undefined'
        ? this.setState({ favorites })
        : this.setState({ favorites: '0' });
    }, 1000);
  }

  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf('nav-toggle') !== -1
    ) {
      document.documentElement.classList.toggle('nav-toggle');
      this.refs.sidebarToggle.classList.toggle('toggled');
    }
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf('nav-toggle-chat') !== -1
    ) {
      document.documentElement.classList.toggle('nav-toggle-chat');
      this.refs.chatToggle.classList.toggle('toggled');
    }
  }

  search(e) {
    e.preventDefault();
    this.setState({ searchAction: true });
    const token = cookies.get('accessToken');
    const lang = this.props.i18n.language;
    const value = this.state.searchValue;
    if (value)
      api
        .search({ token, lang, value })
        .then((result) => {
          if (window.location.pathname === '/search') {
            this.props.history.push({
              pathname: '/search',
              state: { groups: result },
            });
            window.location.reload();
          } else {
            this.props.history.push({
              pathname: '/search',
              state: { groups: result },
            });
          }
          this.setState({ searchAction: false });
        })
        .catch((e) => processError(e, this.props.history));
  }

  addToSearchValue(e) {
    this.setState({ searchValue: e.target.value });
  }

  routeTo(link) {
    this.props.history.push(`/${link}`);
  }

  choseLanguage(e, code) {
    const elems = document.querySelectorAll(
      '.dropdown-item.language.text-primary'
    );
    [].forEach.call(elems, function (el) {
      el.classList.remove('chosen');
    });
    e.target.classList.add('chosen');
    i18next.changeLanguage(code);
    window.location.reload();
  }

  toggleSidebar() {
    const sidebar = document.querySelector('.sidebar.menubar');
    if (sidebar.classList.contains('active'))
      sidebar.classList.remove('active');
    else sidebar.classList.add('active');
  }

  supportModal() {
    if (this.state.supportButton) {
      window.open(this.state.supportButton.value, '_blank');
      //
    } else {
      this.setState({ supportModal: !this.state.supportModal });
    }
  }

  setSent(success) {
    this.setState({ sent: success });
  }

  logout() {
    cookies.remove('accessToken');
    cookies.remove('accessExpired');
    cookies.remove('accessExpiredTime');
    cookies.remove('refreshToken');
    cookies.remove('systemFrontendSettings');
    this.props.history.push('/login');
  }

  render() {
    const { t } = this.props;
    const currentLanguageCode = cookies.get('i18next') || 'en';
    let currentCountryCode;
    let currentName;
    this.state.languages.forEach((lang) => {
      if (lang.code === currentLanguageCode) {
        currentCountryCode = lang.countryCode;
        currentName = lang.name;
      }
    });
    return (
      // add or remove classes depending if we are on full-screen-maps page or not
      <Navbar
        color={
          this.props.location.pathname.indexOf('full-screen-maps') !== -1
            ? 'white'
            : this.state.color
        }
        expand="lg"
        className={
          this.props.location.pathname.indexOf('full-screen-maps') !== -1
            ? 'navbar-absolute fixed-top'
            : 'navbar-absolute fixed-top ' +
              (this.state.color === 'transparent'
                ? 'navbar-transparent '
                : 'navbar-' + this.state.color)
        }
      >
        <Container fluid className="header-container">
          <div className="logo navbar-col">
            <a href={this.state.link} className="simple-text logo-mini">
              <div className="logo-img">
                <div className="logo-mini-img"></div>
                {/* <img src={logomini} className="logo-mini-img" alt="react-logo" /> */}
              </div>
            </a>
            <a href={this.state.link} className="logo-full">
              <div className="logo-full-img"></div>
              {/* <img src={logofull} className="logo-full-img" alt="react-logo" /> */}
            </a>
            <button
              type="button"
              className="navbar-toggler toggled gamburger"
              onClick={() => this.toggleSidebar()}
            >
              <i className="fa fa-bars"></i>
            </button>
          </div>
          <div className="navbar-wrapper ">
            <form className="topbar-search-form" onSubmit={this.search}>
              <InputGroup
                className={
                  'header-searcher topbar-search m-0 ' +
                  (this.state.searchOpen === true ? 'open' : '')
                }
              >
                <Input
                  className="header-searcher-input"
                  placeholder={t('navbar-search')}
                  value={this.state.searchValue}
                  onChange={this.addToSearchValue}
                />
                <div className="header-white-space"></div>
                <InputGroupAddon
                  className="header-sercher-icon-wrapper"
                  addonType="append"
                >
                  <button
                    type="submit"
                    className="btn-unset-css"
                    disabled={this.state.searchAction}
                  >
                    <i className="header-searcher-icon fa fixed-size-fa fa-search"></i>
                  </button>
                </InputGroupAddon>
              </InputGroup>
            </form>
          </div>

          <Button
            type="button"
            className="btn-header ml-2"
            onClick={this.supportModal}
          >
            <EnvelopeSimple size={20} />
            <span className="btn-header-text">
              {t('navbar-write-to-support')}
            </span>
          </Button>

          <Collapse
            isOpen={this.state.isOpen}
            navbar
            className="header-dropdowns"
          >
            <Nav navbar className="d-flex align-items-center">
              <NavItem className="m-0">
                <div className="navbar-toggle chat-toggle">
                  <button
                    type="button"
                    className="navbar-toggler"
                    onClick={() => this.routeTo('favorite')}
                  >
                    <Star size={24} className="primary-color" />
                    {this.state.favorites !== '0' && (
                      <span className="badge badge-pill badge-orange">
                        {this.state.favorites}
                      </span>
                    )}
                  </button>
                </div>
              </NavItem>

              <NavItem className="m-0">
                <div className="navbar-toggle chat-toggle">
                  <button
                    type="button"
                    className="navbar-toggler"
                    onClick={() => this.routeTo('cart')}
                  >
                    <ShoppingCart size={24} className="primary-color" />
                    <span
                      className={`badge badge-pill badge-green ${
                        this.state.items ? '' : 'd-none'
                      }`}
                    >
                      {this.state.items}
                    </span>
                  </button>
                </div>
              </NavItem>

              <NavItem className="m-0">
                <div className="dropdown nav-item mt-0">
                  <button
                    className="btn btn-link dropdown-toggle language-btn"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div className="language-icon-wrapper">
                      <CircleFlag
                        countryCode={currentCountryCode}
                        height="31"
                        className="language-icon"
                      />
                    </div>
                    <span className="current-counrty-code">{currentName}</span>
                  </button>
                  <div
                    className="dropdown-menu dropdown-menu-right language-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    {this.state.languages.map(({ code, name, countryCode }) => (
                      <a key={countryCode} className="dropdown-item-wrapper">
                        <button
                          className={`dropdown-item language text-primary ${
                            code === currentLanguageCode ? 'chosen' : ''
                          }`}
                          onClick={(e) => this.choseLanguage(e, code)}
                          disabled={code === currentLanguageCode}
                          href="#"
                        >
                          <CircleFlag
                            countryCode={countryCode}
                            height="31"
                            className="mr-2 language-icon"
                          />
                          <span className="country-name">{name}</span>
                        </button>
                      </a>
                    ))}
                  </div>
                </div>
              </NavItem>
              <NavItem className="m-0 mr-4 logout" onClick={this.logout}>
                <SignOut className="icon" size={20} color="#CC2B21" />
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
        {this.state.supportModal && (
          <SupportModal
            toggle={this.supportModal}
            isOpen={this.state.supportModal}
            setSent={this.setSent}
          />
        )}
        {this.state.sent === false && (
          <UncontrolledAlert className="email-alert" color="error">
            {t('support-email-fail')}
          </UncontrolledAlert>
        )}
        {this.state.sent === true && (
          <UncontrolledAlert className="email-alert" color="success">
            {t('support-email-sent')}
          </UncontrolledAlert>
        )}
      </Navbar>
    );
  }
}

Header.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  location: PropTypes.object,
  t: PropTypes.func,
  history: PropTypes.object,
  i18n: PropTypes.object,
};

export default withTranslation()(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx